var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1278 4.65036L5.91863 1.5752L6.10643 8.4483L11.969 11.3518L12.1278 4.65036Z",
    fill: "#73CEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0212 8.53199L18.9423 1.60348L12.9036 4.89111L12.9781 11.4329L19.0212 8.53199Z",
    fill: "#73CEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0177 15.9429L25 12.5211L19.0146 9.37312L13.0319 12.5157L19.0177 15.9429Z",
    fill: "#73CEC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9681 12.5211L5.98583 15.9429L0 12.5157L5.98272 9.37312L11.9681 12.5211Z",
    fill: "#73CEC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1113 23.3623L12.9021 20.2871L13.0609 13.5856L18.9235 16.4892L19.1113 23.3623Z",
    fill: "#73CEC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05413 16.4963L6.13306 23.4248L12.1718 20.1372L12.0973 13.5954L6.05413 16.4963Z",
    fill: "#73CEC0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.4f058444c5f5644dcfd4f1bde7db36df.svg";
export { ForwardRef as ReactComponent };